<template>
  <div v-loading="loading" style="min-height: 400px">
    <div class="rj-page-card__title">
      基本信息
    </div>
    <div class="rj-row">
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款编号:
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.telegraphicTransferNo }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入公司：
          </div>
          <div>{{ telegraphicTransfer.importCompany }}</div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            币种：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.currencyName }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            代理名称：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.sourceCompany }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款日期：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.remittanceTime }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.remittanceAmount }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入账户：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.importAccount }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            实际付款人:
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.drawee }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            付款类型:
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.strRemittanceType }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            付款用途:
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.strRemittanceScenario }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            可用余额：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.availableAmount }}
          </div>
        </div>
      </div>
    </div>
    <div class="rj-page-card__title" style="margin-top: 15px">
      水单附件
    </div>
    <el-table :data="tableDataList" border style="width: 100%;margin-top: 10px" height="180">
      <el-table-column prop="fileName" label="文件名称" align="left" />
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column prop="assignAmount" label="操作" align="left">
        <template v-slot="{row}">
          <el-button type="text" @click="downFiles(row.fileToken)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="rj-page-card__title" style="margin-top: 15px">
      电汇所指订单列表
    </div>
    <el-table :data="tableData" border style="width: 100%;margin-top: 10px" height="180">
      <el-table-column type="index" width="60" label="序号" align="left" />
      <el-table-column prop="contractNum" label="锐捷电子商务合同编号" align="left" />
      <el-table-column prop="orderNo" label="分配订单号" align="left" />
      <el-table-column prop="actualSettlementAmount" label="订单总金额" align="right" header-align="left" />
      <el-table-column prop="assignedAmount" label="本次分配金额" align="right" header-align="left" />
      <el-table-column prop="assignedDate" label="分配日期" align="left" width="140px" />
    </el-table>
    <div> 金额小计：{{ telegraphicTransfer.amountSubtotal }}</div>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>
import { telegraphicTransferInternation, confirmApplyForRefund, attachmentGetToken } from '@/API/index';
import { MathAdd } from '@/libs/util';
import eventBus from '@/libs/eventBus';
export default {
  name: 'FinanceremittanceInfoBox',
  data () {
    return {
      tableData: [],
      tableDataList: [],
      loading: false,
      telegraphicTransfer: [],
      totalAssignAmount: 0,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: ''
    };
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  components: {},
  computed: {
    totalAccount () {
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount) {
          num = MathAdd(num, item.assignAmount);
        }
      });
      // num = num.toFixed(2);
      return num;
    }
  },
  methods: {
    selectDetail () {
      telegraphicTransferInternation(this.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.intelContractAssignList;
          this.tableDataList = json.data.attachmentList;
          this.telegraphicTransfer = json.data;
          this.totalAssignAmount = json.data.totalAssignAmount;
        }
      }).catch((res) => {

      });
    },
    confirmApplyForRefund () {
      confirmApplyForRefund(this.id, this.dId, 'Y').then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success('确认退款成功');
          this.$emit('close');
        }
      }).catch((res) => {

      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    downFiles (id) {
      this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    }
  },
  mounted () {
    this.selectDetail();
    this.initToken();
    eventBus.$on('confirmApply', () => {
      this.confirmApplyForRefund();
    });
  },
  destroyed () {
    eventBus.$off('confirmApply');
  }
};
</script>

<style lang="scss">
  .money{
    color: #f60;
  }
</style>
